import { useState } from 'react';
import { Title } from '../../../../component/title/Title';
import TransferList from '../../../../component/transferList/TransferList.component';
import FormEmploee from './form/FormEmplyee.component';
import { INITIAL_VALUES_EMPLOEE } from './utils/INITIAL_VALUES';
import { Container } from '../../../../component/container/Container';
import { getEmployee, getEmployeeGroup, postEmployeeGroup, deleteEmployeeGroup } from './Employee.service';
import Employee from './interfaces/Employee';
import { useSnackbar } from '../../../../context/Snackbar';
import { GroupEmployees } from './interfaces/GroupEmployees';
import FormGroup from '../form/FormGroup.component';
import { INITIAL_VALUES } from '../utils/INITIAL_VALUES';
import Group from '../interfaces/Group';
import { AxiosResponse } from 'axios';

export default function AssignEmployee() {

    const { setSnackbar } = useSnackbar();
    const [groupId, setGroupId] = useState<string>('');
    const [employeeAvailable, setEmployeeAvailable] = useState<Employee[]>([]);
    const [employee, setEmployee] = useState<Employee[]>([]);
    const [reload, setReload] = useState<boolean>(false);

    const handleSubmitForm = async (employee: Employee) => {
        setReload(true);
        await getEmployee(employee.Nome).then(res => {
            setEmployee(res.data);
        }).catch((error) => {
            console.log('error', error);
        }).finally(() => {
            setReload(false);
        });
    }

    const handleSubmitFormGroup = async (group: Group) => {
        setReload(true);
        setGroupId(String(group.Id));
        await getEmployeeGroup(String(group.Id)).then(res => {
            setEmployeeAvailable(res.data);
        }).catch((error) => {
            console.log('error', error);
        }).finally(() => {
            setReload(false);
        });
    }

    const reduceObjectEmployees = (groupId: string, employees: Employee[]): GroupEmployees => {
        let employeesAux: string[] = [];
        employees.map((employee: Employee) => {
            if (employee.UserAD) {
                employeesAux.push(employee.UserAD);
            }
            return employee;
        });
        return { GrupoId: groupId, FuncionarioId: employeesAux };
    }

    const register = async (employees: Employee[], action?: 'ADD' | 'DELETE' | '') => {
        const groupEmployees: GroupEmployees = reduceObjectEmployees(groupId, employees);
        const isAdd: boolean = action === 'ADD';

        const response: Promise<AxiosResponse<GroupEmployees>> = await isAdd ? postEmployeeGroup(groupEmployees) : deleteEmployeeGroup(groupEmployees);

        await response.then((res) => {
            setSnackbar({ msg: `Funcionario foi ${isAdd ? 'inserido' : 'retirado'} com sucesso!`, type: 'success' });
        }).catch((error) => {
            console.log('Error ao submeter comunicado', error);
            setSnackbar({ msg: `Erro ao ${isAdd ? 'inserir' : 'retirar'} funcionario!`, type: 'error' });
        }).finally(() => {
        });
    }

    return (
        <>
            <Title>ATRIBUIÇÃO DE COLABORADORES</Title>
            <Container margin='25px 0px'>
                <FormGroup initialValues={INITIAL_VALUES} handleSubmitForm={handleSubmitFormGroup} />
            </Container>

            {groupId && <Container margin='0px 0px 25px 0px'>
                <FormEmploee initialValues={INITIAL_VALUES_EMPLOEE} handleSubmitForm={handleSubmitForm} />
            </Container>}
            <TransferList
                list={employeeAvailable}
                listAvailable={employee}
                handleSubmit={register}
                request={reload}
                titleRight="Colaboradores Disponíveis"
                titelLeft="Colaboradores Selecionados"
                propertyName={{ id: 'UserAD', name: 'Nome' }}
            />
        </>
    );
}